import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import IPaginatedesponse from '@models/paginated-reponse';
import JobItem from '@jobs/models/dto/job-item';
import GetJobItemDto from '@jobs/models/dto/get-job-item.dto';

export const getJobs = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<JobItem>>> => {
  return await axiosClient.post(
    EndPoints.jobs.getJobs(paginatedParams),
    searchCriteria,
  );
};

export const getJobById = async (
  id: string,
): Promise<AxiosResponse<GetJobItemDto>> => {
  return await axiosClient.get(EndPoints.jobs.getJobById(id));
};

export const disableJobById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.jobs.disableJobById(id));
};

export const enableJobById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.jobs.enableJobById(id));
};
